import {
  QueryClient,
  QueryClientProvider as TanStackQueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactNode, FC } from "react";

const oneHourInMs = 1000 * 60 * 60;

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: oneHourInMs,
      retry: false,
    },
  },
});

type QueryClientProviderProps = {
  children: ReactNode;
};

const QueryClientProvider: FC<QueryClientProviderProps> = ({ children }) => {
  return (
    <TanStackQueryClientProvider client={client}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </TanStackQueryClientProvider>
  );
};
export default QueryClientProvider;
